import { getRuleFiltersConfigBySection } from '@kw/quokka-ui';
import { FiltersAndTable } from '../FiltersAndTable';

interface IProps {
  ruleSummaries: object;
  analysisId: string;
}

export const Permissions = ({ ruleSummaries, analysisId }: IProps) => {
  return <FiltersAndTable analysisId={analysisId} data={ruleSummaries} filterSection="permission" />;
};
